import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  projectExpenseTypes: [],
};

function handleRetrieveProjectExpenseTypesRequest(state: State): State {
  return { ...state, request: setRequestStateToPending() };
}

function handleRetrieveProjectExpenseTypesSuccess(
  state: State,
  projectExpenseTypes: Boundaries["retrieveProjectExpenseTypes"]["success"],
): State {
  return { projectExpenseTypes, request: setRequestStateToSuccess() };
}

function handleRetrieveProjectExpenseTypesFailure(state: State): State {
  return { ...state, request: setRequestStateToFailure() };
}

function handleCreateProjectExpenseTypeRequest(
  state: State,
  { projectExpenseType }: Boundaries["createProjectExpenseType"]["request"],
): State {
  return {
    ...state,
    projectExpenseTypes: [
      { ...projectExpenseType, uuid: projectExpenseType.name },
      ...state.projectExpenseTypes,
    ],
  };
}

function handleCreateProjectExpenseTypeSuccess(
  state: State,
  { projectExpenseType }: Boundaries["createProjectExpenseType"]["success"],
): State {
  return {
    ...state,
    projectExpenseTypes: [
      projectExpenseType,
      ...state.projectExpenseTypes.filter(
        ({ uuid }) => uuid !== projectExpenseType.name,
      ),
    ],
  };
}

function handleCreateProjectExpenseTypeFailure(
  state: State,
  { projectExpenseType }: Boundaries["createProjectExpenseType"]["failure"],
): State {
  return {
    ...state,
    projectExpenseTypes: state.projectExpenseTypes.filter(
      ({ uuid }) => uuid !== projectExpenseType.name,
    ),
  };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveProjectExpenseTypesRequested]:
      handleRetrieveProjectExpenseTypesRequest,
    [events.retrieveProjectExpenseTypesSucceeded]:
      handleRetrieveProjectExpenseTypesSuccess,
    [events.retrieveProjectExpenseTypesFailed]:
      handleRetrieveProjectExpenseTypesFailure,
    [events.createProjectExpenseTypeRequested]:
      handleCreateProjectExpenseTypeRequest,
    [events.createProjectExpenseTypeSucceeded]:
      handleCreateProjectExpenseTypeSuccess,
    [events.createProjectExpenseTypeFailed]:
      handleCreateProjectExpenseTypeFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
